import { Product } from '../../../catalog/products/product';
import { Convergence } from '../../../checkout/cart/promotions/convergence.class';
import { Customer } from '../../../checkout/cart/promotions/customer.class';
import { Porta } from '../../../checkout/cart/promotions/porta.class';
import { Promotion } from '../../../checkout/cart/promotions/promotion.class';
import { IPromotionToTransform, IPromotions } from '../../../checkout/cart/promotions/promotion.interface';
import { PromoContextService } from '../../../context/child/promo-context.service';
import { ConfiguratorType } from './interface/configurable';
import { PriceTypes } from './product';

export abstract class SubscriptionBase extends Product {
    public hasContract: boolean = true;

    constructor(data: any, uniqueId: string = '') {
        super(data, uniqueId);
        this.priceType = PriceTypes.EvryMonth;
    }

    protected updatePrice(): void {
        super.updatePrice();
        this.duration = this.obligation ? Number(this.obligation.replace(/[^\d]/g, '')) : null;
    }

    /**
     *
     * @protected
     * @returns
     * @memberof Product
     */
    public updatePromotion(): void {
        const promoContext: PromoContextService =
            this.context.contextService.get<PromoContextService>(PromoContextService);
        if (!promoContext || !promoContext.promotions) {
            return;
        }

        promoContext.promotions = this.filterPromosByStatus(promoContext.promotions);
        promoContext.convergence = this.filterPromosByStatus(promoContext.convergence);

        const promotions: IPromotions[] = Promotion.refactorJson(promoContext.promotions);
        const convergence: IPromotions[] = Convergence.refactorJson(
            promoContext.convergence,
            ConfiguratorType.CONVERGENCE,
        );
        const customer: IPromotions[] = Promotion.refactorJson(promoContext.promotions, ConfiguratorType.CUSTOMER);
        const locales: IPromotions[] = Convergence.refactorJson(promoContext.promotions, ConfiguratorType.LOCALES);
        const porta: IPromotions[] = Porta.refactorJson(promoContext.promotions, ConfiguratorType.PORTA);

        this.promotion = Promotion.getRules(promotions, this);
        this.porta = Porta.getRules(porta, this);
        this.convergence = Customer.getRules(convergence, this);
        this.customer = Customer.getRules(customer, this);
        this.locales = Promotion.getRules(locales, this);
    }

    private filterPromosByStatus(promotions: IPromotionToTransform[]): IPromotionToTransform[] {
        return promotions.filter((promo) => {
            const isProPromo: boolean =
                promo.conditions.status.includes('ENTREPRISE') || promo.conditions.status.includes('ALL');
            const isIndividuPromo: boolean =
                promo.conditions.status.includes('INDIVIDU') || promo.conditions.status.includes('ALL');

            return (isProPromo && this.data.is_pro) || (isIndividuPromo && !this.data.is_pro);
        });
    }

    protected applyAml(): boolean {
        return true;
    }

    protected applyPromo(): boolean {
        return true;
    }
}
